import { ProjectDeliverablesScreen_TableFragment } from "../../../fragments.generated";

export function mapTableToHtmlForClipboard(table: ProjectDeliverablesScreen_TableFragment): string {
    const root = document.createElement("table");
    root.style = mapObjectToStyles(tableStyles);
    const thead = document.createElement("thead");
    const tbody = document.createElement("tbody");

    // Table header style
    const th_row = document.createElement("tr");
    thead.append(th_row);

    // Create table header
    for (const column of table.columns) {
        const th = document.createElement("th");
        th.textContent = column.title;
        th.style = mapObjectToStyles(tableHeaderStyle);
        th_row.append(th);
    }

    // Create table body
    for (const row of table.rows) {
        const tr = document.createElement("tr");

        for (const column of row.columns) {
            const isSubheader = column.colSpan === table.columns.length;
            const isEven = row.index % 2 === 0;
            const td = document.createElement("td");

            td.textContent = column.value;
            td.colSpan = column.colSpan ?? 1;
            td.style = isSubheader
                ? mapObjectToStyles(tableSubheaderStyle)
                : isEven
                  ? mapObjectToStyles(tableCellEvenStyle)
                  : mapObjectToStyles(tableCellOddStyle);

            tr.append(td);
        }

        tbody.append(tr);
    }

    root.append(thead, tbody);
    return root.outerHTML;
}

function mapObjectToStyles(obj: Record<string, any>): string {
    return Object.entries(obj)
        .map(([key, value]) => `${key}: ${value};`)
        .join(" ");
}

const tableStyles = {
    width: "100%",
};

const tableHeaderStyle = {
    "background-color": "#033A20",
    color: "#fff",
    "font-size": "11px",
};

const tableSubheaderStyle = {
    "background-color": "#0AAF5F",
    color: "#fff",
    "font-size": "11px",
};

const tableCellEvenStyle = {
    "background-color": "#F5F5F5",
    color: "#1F2321",
    "font-size": "11px",
};

const tableCellOddStyle = {
    "background-color": "#EDEDED",
    color: "#1F2321",
    "font-size": "11px",
};
